interface CollectionItemLike {
  product?: {
    inventory?: {
      qty?: number | null
    } | null
  } | null
}

/**
 * Whether a campaign gift option is sent from the customer's My Inventory.
 * A prepaid campaign is fully covered by inventory; otherwise an item counts
 * as inventory when the customer still holds stock of it.
 * Same rule as the inventory badge on gift option images.
 */
export function isProductFromInventory (item: CollectionItemLike | null | undefined, isPrepaid = false): boolean {
  if (isPrepaid) return true

  return Number(item?.product?.inventory?.qty) > 0
}
